// extra/uuid.ts
import { StringValidator } from "../validators/string.mjs";
var UUID_EXPR = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
var UUIDValidator = class extends StringValidator {
  constructor() {
    super({ minLength: 36, maxLength: 36, pattern: UUID_EXPR });
  }
  validate(value) {
    return super.validate(value).toLowerCase();
  }
};
var uuid = new UUIDValidator();
export {
  UUIDValidator,
  UUID_EXPR,
  uuid
};
//# sourceMappingURL=uuid.mjs.map
